<template>
  <div class="review-card-container">
    <VueSlickCarousel ref="carousel" v-bind="settings">
      <article v-for="review in reviews" :key="review.name">
        <div class="review-card">
          <h5 class="name">{{ review.name }}</h5>
          <div class="stars">
            <img src="/images/star.png" alt="Star" v-for="n in review.stars" :key="n" />
          </div>
          <div class="wysiwyg" v-html="review.description"></div>
          <div class="date">
            <img src="/images/google-g.png" alt="Google" />
            <span>{{ review.date }}</span>
          </div>
        </div>
      </article>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: {
    VueSlickCarousel,
  },

  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      settings: {
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
};
</script>
